import { getType, subTypes, types } from "./itemTypes";

export function getItem(question) {
  let newQuestion = question?.original
    ? JSON.parse(JSON.stringify(question.original))
    : {
        itemExtra: {},
      };
  newQuestion.shortQuestion = question.label ?? "";
  newQuestion.fullQuestion = question.title ?? "";
  // curate
  if (question.original?.itemExtra?.curate) {
    if (question.checked) {
      delete newQuestion.itemExtra.hide;
    } else {
      newQuestion.itemExtra.hide = 1;
    }
  }
  switch (question.type) {
    case subTypes.open:
      newQuestion.typeQuestion = subTypes.open;
      break;

    case subTypes.singleChoice:
    case subTypes.multipleChoice:
      newQuestion.typeQuestion = subTypes.multipleChoice;
      if (question.hasImages) {
        newQuestion.typeQuestion = subTypes.imageChoice;
        newQuestion.itemExtra.imageLocations = question.options.map(
          (option) => option.img
        );
      }
      newQuestion.itemExtra.allowMultipleChoice =
        question.type === subTypes.singleChoice ? false : true;
      newQuestion.itemExtra.options = question.options.map(
        (option) => option.title
      );
      //newQuestion.itemExtra.showEnum = false;
      break;

    case subTypes.likert:
      newQuestion.typeQuestion = subTypes.multipleChoice;
      //newQuestion.itemExtra.allowMultipleChoice = false;
      newQuestion.itemExtra.options = question.options.map(
        (option) => option.title
      );
      newQuestion.itemExtra.optionVals = question.options.map(
        (option) => option.number
      );
      break;

    case subTypes.order:
      newQuestion.typeQuestion = subTypes.order;
      newQuestion.itemExtra.options = question.options.map(
        (option) => option.title
      );
      break;

    case subTypes.yesno:
      newQuestion.typeQuestion = subTypes.yesno;
      break;

    case subTypes.multiSmiley:
      newQuestion.typeQuestion = subTypes.multiSmiley;
      break;

    case subTypes.bodyParts:
      newQuestion.typeQuestion = subTypes.bodyParts;
      break;

    case subTypes.slider:
      if (
        question.marks[0].type === "not at all" &&
        question.marks[1].type === "extremely"
      ) {
        // default sliderNegPos
        newQuestion.typeQuestion = subTypes.sliderNegPos;
        newQuestion.itemExtra.useAnchors = 0;
      } else if (
        // default sliderNeutralPos
        question.marks[0].type === "neutral" &&
        question.marks[1].type === "extremely"
      ) {
        newQuestion.itemExtra.useAnchors = 0;
        newQuestion.typeQuestion = subTypes.sliderNeutralPos;
      } else {
        // custom slider
        newQuestion.typeQuestion = subTypes.sliderNegPos;
        newQuestion.itemExtra.useAnchors = 1;
        newQuestion.itemExtra.anchorLeft = question.marks[0].label;
        newQuestion.itemExtra.anchorRight = question.marks[1].label;
      }
      newQuestion.itemExtra.minInt = question.marks[0].value;
      newQuestion.itemExtra.maxInt = question.marks[1].value;
      break;

    case subTypes.smiley:
      newQuestion.typeQuestion = subTypes.smiley;
      newQuestion.itemExtra.typeSmiley = question.typeSmiley;
      break;

    case subTypes.computation:
      if (!question.isText) {
        // expressionString of a computation is a number
        newQuestion.itemExtra.expressionString = question.expressionString;
      }
      break;

    case subTypes.text:
      newQuestion.typeQuestion = subTypes.text;
      break;
    default:
      break;
  }
  // default value
  if (question.defaultValue !== undefined) {
    const previousDefaultValues = question?.original?.defaultValue ?? {};
    const defaultValue = { [newQuestion.typeQuestion]: question.defaultValue };
    newQuestion.defaultValue = { ...previousDefaultValues, ...defaultValue };
  }
  return newQuestion;
}

function getCondition(child, parent) {
  const parentType = getItem(parent).typeQuestion;
  const primaryCond = child.conditions;
  switch (getType(parent.type)) {
    case types.choice:
      if ([subTypes.yesno, subTypes.computation].includes(parent.type)) {
        return {
          [parentType]: parent.options
            .map((option, index) => ({ optionId: option.id, value: index }))
            .filter(({ optionId }) => primaryCond.includes(optionId))
            .map(({ value }) => value),
        };
      }
      if ([subTypes.multiSmiley, subTypes.bodyParts].includes(parent.type)) {
        return {
          [parentType]: parent.options
            .filter((option) => primaryCond.includes(option.id))
            .map((option) => option.type),
        };
      }
      return {
        [parentType]: parent.options
          .map((option, index) => ({ optionId: option.id, value: index + 1 }))
          .filter(({ optionId }) => primaryCond.includes(optionId))
          .map(({ value }) => value),
      };

    case types.slider:
      return {
        [parentType]:
          primaryCond.length === 2
            ? [primaryCond[0].value, primaryCond[1].value]
            : [],
      };

    case types.container:
      return {};

    default:
      return child?.original?.condition ?? {};
  }
}

export function exportQuestions(questionTree, details) {
  const buildTree = (initialItems) => {
    return initialItems.map((item) => {
      // item defaults
      let node = getItem(item.value);
      // conditional
      if (item.parentKey !== "root") {
        const previousConditions = item?.condition ?? {};
        const condition = getCondition(
          item.value,
          questionTree.getItem(item.parentKey).value
        );
        node.condition = { ...previousConditions, ...condition };
      }
      // children
      node.items = buildTree(item.children);
      return node;
    });
  };
  const questionList = {
    ...details,
    items: buildTree(questionTree.getItem("root").children),
  };
  return questionList;
}

export function exportQuestionsFromLib(questions, details) {
  const buildTree = (initialItems, parent) => {
    return initialItems.map((item) => {
      // item defaults
      let node = getItem(item);
      // conditional
      if (parent !== "root") {
        const previousConditions = item?.original?.condition ?? {};
        const condition = getCondition(item, parent);
        node.condition = { ...previousConditions, ...condition };
      }
      // children
      node.items = buildTree(item.items, item);
      return node;
    });
  };
  const questionList = {
    ...details,
    items: buildTree(questions, "root"),
  };
  return questionList;
}

export default exportQuestions;
